import cascder from "./index.vue";
const commonCascder = {
  install: function (Vue) {
    Vue.component("commonCascder", cascder);
  },
};
// 导出该组件
export default commonCascder;
